import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const versionNumber = '1.0.105';
// export const env = 'dev';
// export const env = 'qa';
export const env = 'prod';
export const ENV = env;

const DEV_URLS = {
  baseURL: process.env.NEXT_PUBLIC_QA_BASE_URL,
  userURL: process.env.NEXT_PUBLIC_QA_USER_URL,
  orderURL: process.env.NEXT_PUBLIC_QA_ORDER_URL,
  paymentsURL: process.env.NEXT_PUBLIC_QA_PAYMENTS_URL,
  restURL: process.env.NEXT_PUBLIC_QA_REST_URL,
  urlForLocalImage: process.env.NEXT_PUBLIC_QA_LOCAL_IMAGE_URL,
  socketUrl: process.env.NEXT_PUBLIC_QA_SOCKET_URL,
  currentLocationUrl: process.env.NEXT_PUBLIC_QA_CURRENT_LOCATION_URL,
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  whatsAppUrl: process.env.NEXT_PUBLIC_QA_WHATSAPP_URL,
};

const QA_URLS = {
  baseURL: process.env.NEXT_PUBLIC_QA_BASE_URL,
  userURL: process.env.NEXT_PUBLIC_QA_USER_URL,
  orderURL: process.env.NEXT_PUBLIC_QA_ORDER_URL,
  paymentsURL: process.env.NEXT_PUBLIC_QA_PAYMENTS_URL,
  restURL: process.env.NEXT_PUBLIC_QA_REST_URL,
  urlForLocalImage: process.env.NEXT_PUBLIC_QA_LOCAL_IMAGE_URL,
  socketUrl: process.env.NEXT_PUBLIC_QA_SOCKET_URL,
  currentLocationUrl: process.env.NEXT_PUBLIC_QA_CURRENT_LOCATION_URL,
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  whatsAppUrl: process.env.NEXT_PUBLIC_QA_WHATSAPP_URL,
};

const PROD_URLS = {
  baseURL: process.env.NEXT_PUBLIC_PROD_BASE_URL,
  userURL: process.env.NEXT_PUBLIC_PROD_USER_URL,
  orderURL: process.env.NEXT_PUBLIC_PROD_ORDER_URL,
  paymentsURL: process.env.NEXT_PUBLIC_PROD_PAYMENTS_URL,
  restURL: process.env.NEXT_PUBLIC_PROD_REST_URL,
  urlForLocalImage: process.env.NEXT_PUBLIC_PROD_LOCAL_IMAGE_URL,
  socketUrl: process.env.NEXT_PUBLIC_PROD_SOCKET_URL,
  currentLocationUrl: process.env.NEXT_PUBLIC_PROD_CURRENT_LOCATION_URL,
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  whatsAppUrl: process.env.NEXT_PUBLIC_PROD_WHATSAPP_URL,
};

const getURL = (type) => {
  const urlMap = env === 'dev' ? DEV_URLS : env === 'qa' ? QA_URLS : PROD_URLS;
  return urlMap[type] || '';
};

export const CONFIG = {
  appName: 'Shahen Logistics',
  appVersion: packageJson.version,
  serverUrl:
    env === 'qa'
      ? `${process.env.NEXT_PUBLIC_CLIENT_URL}/EnhancedUI`
      : env === 'prod'
        ? process.env.NEXT_PUBLIC_CLIENT_URL
        : 'http://localhost:3002',
  assetsDir: process.env.NEXT_PUBLIC_ENV === 'qa' ? '/EnhancedUI' : '',
  baseURL: getURL('baseURL'),
  userURL: getURL('userURL'),
  orderURL: getURL('orderURL'),
  paymentsURL: getURL('paymentsURL'),
  restURL: getURL('restURL'),
  urlForLocalImage: getURL('urlForLocalImage'),
  apiKey: getURL('apiKey'),
  socketUrl: getURL('socketUrl'),
  currentLocationUrl: getURL('currentLocationUrl'),
  whatsAppUrl: getURL('whatsAppUrl'),
  googleMapApiKey: process.env.NEXT_PUBLIC_MAP_API ?? '',
  // googleMapApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '',
};
